import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import EmbedLogin from './EmbedLogin.jsx';

export default function ProtectedRoute({ children, roles }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div className="loading">Загрузка…</div>;
  }
  if (!isAuthenticated) {
    // Встроенная карта (АРМ): показываем форму входа прямо тут, без редиректа.
    if (new URLSearchParams(location.search).get('embed') === '1') return <EmbedLogin />;
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
